import React, { useEffect, useState } from "react";
import { facebook, instragram, telegram, watup2 } from "../../assets/img";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Loader from "../../Component/Loader";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import SubmitButton from "../../Component/SubmitButton";
import CommonPopup from "../../Component/CommonPopup";

const AddLink = () => {

  const { kv, set } = useStoreKv();
  const links = kv.links || [];

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState(links ?? {
    whatspp: "",
    facebook: "",
    telegram: "",
    instagram: "",
    whatspp_group: "",
  });

  // ✅ Fetch existing links
  const getList = async () => {
    try {
      // setLoading(true);
      const res = await get(`${URLS.MASTER}?type=5`);
      //       console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        setFormData({
          whatspp: res.data.whatspp || "",
          facebook: res.data.facebook || "",
          telegram: res.data.telegram || "",
          instagram: res.data.instagram || "",
          whatspp_group: res.data.whatspp_group || "",
        });
        set("links", {
          whatspp: res.data.whatspp || "",
          facebook: res.data.facebook || "",
          telegram: res.data.telegram || "",
          instagram: res.data.instagram || "",
          whatspp_group: res.data.whatspp_group || "",
        });
      } else {
        Toast(res?.message || "No data found");
        set("links", {
          whatspp: "",
          facebook: "",
          telegram: "",
          instagram: "",
          whatspp_group: "",
        });
      }
    } catch (err) {
      Toast("Failed to load links");
      console.error(err);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Handle update (POST)
  const handleChangeLinks = async () => {
    try {
      setLoading2(true);
      const payload = {
        id: 5,
        ...formData
      };
      const res = await post(`${URLS.LINKUPDATE}`, payload);
      //       console.log("Update response:", res);

      if (res?.status === "success") {
        Toast("Links updated successfully!");
        setLoading2(false);
        setPopup(false);
      } else {
        Toast(res?.message || "Update failed!");
        setLoading2(false);
        setPopup(false);
      }
    } catch (err) {
      Toast("Error updating links");
      console.error(err);
    } finally {
      setLoading2(false);
      setPopup(false);
    }
  };

  // ✅ Open link in new tab
  const openLink = (url) => {
    if (url && url.startsWith("http")) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      Toast("Invalid URL");
    }
  };

  // ✅ Style for clickable link labels
  const clickableStyle = (url) => ({
    cursor: url ? "pointer" : "default",
    // borderBottom: url ? "1px solid rgb(19 19 19)" : "none",
    display: "inline-block",
    paddingBottom: "2px",
    transition: "border-color 0.2s ease",
  });

  return (
    <div className="dashRightView">
      <div className="container_overall col-md-5 my-3">
        {/* WhatsApp */}
        <div className="d-flex ac-js gap-1">
          <img src={watup2} width={30} height={30} alt="" />
          <p
            className="f3 fs-xs-14 fs-md-15 fs-lg-17 fs-xl-18 gray"
            style={clickableStyle(formData.whatspp)}
            onClick={() => openLink(formData.whatspp)}
          >
            WhatsApp
          </p>
        </div>
        <div className="col-md-5">
          <input
            className="input-box mt-2 mb-4 placholdercolorchanges2"
            type="url"
            style={{ backgroundColor: 'white', fontSize: 14 }}
            name="whatspp"
            value={formData.whatspp}
            onChange={handleChange}
            placeholder="Enter WhatsApp Link"
          />
        </div>
        {/* WhatsApp Group */}
        <div className="d-flex ac-js gap-1">
          <img src={watup2} width={30} height={30} alt="" />
          <p
            className="f3 fs-xs-14 fs-md-15 fs-lg-17 fs-xl-18 gray"
            style={clickableStyle(formData.whatspp_group)}
            onClick={() => openLink(formData.whatspp_group)}
          >
            WhatsApp Group
          </p>
        </div>
        <div className="col-md-5">
          <input
            className="input-box mt-2 mb-4 placholdercolorchanges2"
            type="url"
            name="whatspp_group"
            style={{ backgroundColor: 'white', fontSize: 14 }}
            value={formData.whatspp_group}
            onChange={handleChange}
            placeholder="Enter WhatsApp Group Link"
          />
        </div>
        {/* Telegram */}
        <div className="d-flex ac-js gap-1">
          <img src={telegram} width={30} height={30} alt="" />
          <p
            className="f3 fs-xs-14 fs-md-15 fs-lg-17 fs-xl-18 gray"
            style={clickableStyle(formData.telegram)}
            onClick={() => openLink(formData.telegram)}
          >
            Telegram
          </p>
        </div>
        <div className="col-md-5">
          <input
            className="input-box mt-2 mb-4 placholdercolorchanges2"
            type="url"
            name="telegram"
            value={formData.telegram}
            style={{ backgroundColor: 'white', fontSize: 14 }}
            onChange={handleChange}
            placeholder="Enter Telegram Group Link"
          />
        </div>
        {/* Instagram */}
        <div className="d-flex ac-js gap-1">
          <img src={instragram} width={30} height={30} alt="" />
          <p
            className="f3 fs-xs-14 fs-md-15 fs-lg-17 fs-xl-18 gray"
            style={clickableStyle(formData.instagram)}
            onClick={() => openLink(formData.instagram)}
          >
            Instagram
          </p>
        </div>
        <div className="col-md-5">
          <input
            className="input-box mt-2 mb-4 placholdercolorchanges2"
            type="url"
            name="instagram"
            value={formData.instagram}
            style={{ backgroundColor: 'white', fontSize: 14 }}
            onChange={handleChange}
            placeholder="Enter Instagram Link"
          />
        </div>
        {/* Facebook */}
        <div className="d-flex ac-js gap-1">
          <img src={facebook} width={30} height={30} alt="" />
          <p
            className="f3 fs-xs-14 fs-md-15 fs-lg-17 fs-xl-18 gray"
            style={clickableStyle(formData.facebook)}
            onClick={() => openLink(formData.facebook)}
          >
            Facebook
          </p>
        </div>
        <div className="col-md-5">
          <input
            className="input-box mt-2 mb-4 placholdercolorchanges2"
            type="url"
            name="facebook"
            value={formData.facebook}
            style={{ backgroundColor: 'white', fontSize: 14 }}
            onChange={handleChange}
            placeholder="Enter Facebook Link"
          />
        </div>
        {/* Update Button */}
        <div style={{ width: '100%' }} className="col-md-5 mb-5">
          {/* <button
            onClick={() => setPopup(true)}
            className="add-button f3 fs-xs-15 fs-md-13 fs-lg-15"
            disabled={loading}
            style={{ marginBottom: 50, color: "black" }}
          >
            Update
          </button> */}
          <SubmitButton
            onClick={() => setPopup(true)}
            disabled={loading}
            style={{ marginBottom: 50 }}
            title="Update"
          />
        </div>
      </div>
      {loading && <Loader />}
      {/* {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Are you sure you want to Update?
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2  f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
              <button onClick={() => setPopup(false)} className="no-btn w-40">
                No
              </button>
              <button
                onClick={handleChangeLinks}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {loading2 ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "black", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  <span style={{ top: -1.5, position: 'relative' }}>Yes</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )} */}

      <CommonPopup
        isOpen={popup}
        message="Are you sure you want to Update?"
        onClose={() => setPopup(false)}
        onConfirm={handleChangeLinks}
        loading={loading2}
      />
    </div>
  );
};

export default AddLink;
